export default __webpack_public_path__ + "static/media/RuthMap.101f51f8.png";